import * as React from 'react';

import { OtherItemsCategoryList } from './components/OtherItemsCategory/components/OtherItemsCategoryList';

export const OtherItemsCategoryPage: React.FC = () => {
  return (
    <>
      <OtherItemsCategoryList />
    </>
  );
};

export default OtherItemsCategoryPage;
